import { MergeAccounts } from "./merge-accounts"
import React, { FC, useEffect, useContext } from "react"
import { UserProfile, getUserProfileV2Local  } from "@chr/online-shared-microsite-core";
import { useHistory } from "react-router-dom";
import { Header, Footer } from "@chr/navisphereonline-shared-components";
import { ConfigContext, AuthContext } from "@chr/navisphereonline-shared-components";

const MergeAccountsWrapper: FC = () => {
  const appConfig = useContext(ConfigContext);
  const authClient = useContext(AuthContext);
  const user: UserProfile | null = getUserProfileV2Local();
  const history = useHistory();

  useEffect(() => {
    if(!user) {
      history.push('/pagenotfound');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    user ?
      <>
        <Header appConfig={{...appConfig, allowGuests: false}} authClient={authClient} />
        <MergeAccounts user={user} />
        <Footer/>
      </>
    : null
  )
}

export default MergeAccountsWrapper;
